import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { TabularTypeDatasetAdapter, tabularPropertiesCommonAdapts } from './tabular-type.dataset.adapter';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { SalesforceDataset } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SalesforceDataset),
    disabled: __IS_FABRIC_DPE__,
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            ...tabularPropertiesCommonAdapts,
            typeProperties: {
                objectApiName: '*',
                tableName: '*' // backward compatibility
            }
        }
    }
})
export class SalesforceDatasetAdapter extends TabularTypeDatasetAdapter<SalesforceDataset, Model.DatasetResource> {
    protected async _toResource(dataset: SalesforceDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(SalesforceDataset).name, 'objectApiName');
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: SalesforceDataset): Promise<SalesforceDataset> {
        if (!dataset) {
            dataset = SalesforceDataset.MODEL.create<SalesforceDataset>(modelDatasetResource.name);
        }
        await super._toModel(modelDatasetResource, dataset);
        const model = modelDatasetResource.properties as Model.SalesforceObjectDataset;
        if (model) {
            if (model.typeProperties) {
                ValueAdapter.toModel(dataset, SalesforceDataset.TABLE_NAME, model.typeProperties.objectApiName != null ?
                    model.typeProperties.objectApiName : (modelDatasetResource.properties as Model.RelationalTableDataset).typeProperties.tableName); // hanlde both tableName and ObjectApiName
            }
            dataset.columns = this.columnResourceToValue(dataset, model.structure);
        }

        dataset.raw = JSON.stringify(await ValueAdapter.remainder(this.context, modelDatasetResource, SalesforceDataset.MODEL));
        return dataset;
    }
}
